import { useState } from "react"
import { PortalContainer } from "../main/Portal";
import { Padder, SimpleButton } from "./SimpleElements";
import { useTranslation } from "react-i18next";
import { Config } from "../../../biz/data/Config";

export const ReloadWebPage = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(true);
    const clickOutside = () => {
        setVisible(false);
        setTimeout(() => {
            setVisible(true);
        }, 60 * 1000);
    };

    return (
        <PortalContainer visible={visible} clickOutside={clickOutside}>
            <div className="reload-page">


                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path d="M15 6.75C12.0469 6.75 9.32812 8.34375 7.82812 10.875C6.375 13.4531 6.375 16.5938 7.82812 19.125C9.32812 21.7031 12.0469 23.25 15 23.25C17.9062 23.25 20.625 21.7031 22.125 19.125C23.5781 16.5938 23.5781 13.4531 22.125 10.875C20.625 8.34375 17.9062 6.75 15 6.75ZM15 25.5C11.2031 25.5 7.78125 23.5312 5.90625 20.25C3.98438 17.0156 3.98438 13.0312 5.90625 9.75C7.78125 6.51562 11.2031 4.5 15 4.5C18.75 4.5 22.1719 6.51562 24.0469 9.75C25.9688 13.0312 25.9688 17.0156 24.0469 20.25C22.1719 23.5312 18.75 25.5 15 25.5ZM3.89062 6.5625C4.45312 6.89062 4.59375 7.59375 4.26562 8.10938C2.95312 10.125 2.25 12.4688 2.25 15C2.25 17.5781 2.95312 19.9219 4.26562 21.8906C4.59375 22.4531 4.45312 23.1094 3.89062 23.4844C3.375 23.8125 2.67188 23.6719 2.34375 23.1094C0.84375 20.8125 0 18 0 15C0 12.0469 0.84375 9.23438 2.34375 6.89062C2.67188 6.375 3.375 6.23438 3.89062 6.5625ZM26.0625 6.5625C26.5781 6.23438 27.2812 6.375 27.6094 6.89062C29.1094 9.23438 30 12.0469 30 15C30 18 29.1094 20.8125 27.6094 23.1094C27.2812 23.6719 26.5781 23.8125 26.0625 23.4844C25.5 23.1094 25.3594 22.4531 25.6875 21.8906C27 19.9219 27.75 17.5781 27.75 15C27.75 12.4688 27 10.125 25.6875 8.10938C25.3594 7.59375 25.5469 6.89062 26.0625 6.5625ZM15 9C15.6094 9 16.125 9.51562 16.125 10.125V15.375C16.125 16.0312 15.6094 16.5 15 16.5C14.3438 16.5 13.875 16.0312 13.875 15.375V10.125C13.875 9.51562 14.3438 9 15 9ZM16.5 19.5C16.5 20.3438 15.7969 21 15 21C14.1562 21 13.5 20.3438 13.5 19.5C13.5 18.7031 14.1562 18 15 18C15.7969 18 16.5 18.7031 16.5 19.5Z" fill="#9F8E73" />
                </svg>

                <div className="header">
                    {t("thereIsANewVersion")}
                </div>

                <div className="text">
                    {t("thereIsANewVersionOfTheApplication")}
                </div>


                <div className="button-row">
                    <SimpleButton
                        onClick={() => window.location.reload()}
                        label={t("reload") + "..."}
                    />
                    <SimpleButton
                        onClick={clickOutside}
                        label={t("waitAMinute") + "..."}
                        type="secondarybeige30"
                    />
                </div>
            </div>
        </PortalContainer>
    )
}